export const STATUS_FRANCO_BLOCKED = 'BLOCKED';
export const STATUS_FRANCO_NORMAL = 'NORMAL';
